function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.01,
  d: "M0 0h48v48H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.19.413a1 1 0 0 1 1.625.008C28.835 6.077 35.527 8.919 45 8.919a1 1 0 0 1 1 1c0 17.877-7.198 30.586-21.542 37.97a1 1 0 0 1-.92-.002l-.464-.242C9.04 40.225 2 27.599 2 9.919a1 1 0 0 1 1-1c9.302 0 15.922-2.741 19.957-8.185zM24 2.649l-.184.225c-4.325 5.165-10.933 7.835-19.748 8.033h-.06l.015.71C4.45 27.495 10.95 38.79 23.556 45.634l.443.237.444-.236C37.2 38.707 43.7 27.225 43.99 11.055l.001-.148-.597-.015c-8.55-.293-14.98-2.962-19.215-8.024L24 2.649zM30 30v2H18v-2h12zm1.128-13.408l1.28 1.536-10.363 8.64a1 1 0 0 1-1.258.018l-.096-.085-5.105-5.2 1.427-1.4 4.459 4.54 9.656-8.05z"
}));

var SvgCreditshell = function SvgCreditshell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditshell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/creditshell.5f50e31f.svg";
export { ForwardRef as ReactComponent };